export enum IMTSDocumentApprovalStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

export const IMTSDocumentApprovalStatusText: Record<
  IMTSDocumentApprovalStatus,
  string
> = {
  [IMTSDocumentApprovalStatus.Pending]: "Pending",
  [IMTSDocumentApprovalStatus.Approved]: "Approved",
  [IMTSDocumentApprovalStatus.Rejected]: "Rejected",
};

export const getIMTSDocumentApprovalStatusStyle = (
  status: IMTSDocumentApprovalStatus,
): { bgColor: string; textColor: string; dotColor: string } => {
  switch (status) {
    case IMTSDocumentApprovalStatus.Approved:
      return {
        bgColor: "tw-bg-[#ECFDF3]",
        textColor: "tw-text-[#027A48]",
        dotColor: "tw-bg-[#12B76A]",
      };
    case IMTSDocumentApprovalStatus.Rejected:
      return {
        bgColor: "tw-bg-[#FDD4D2]",
        textColor: "tw-text-[#B54708]",
        dotColor: "tw-bg-[#F04438]",
      };
    default:
      return {
        bgColor: "tw-bg-[#F5F5F5]",
        textColor: "tw-text-[#414651]",
        dotColor: "tw-bg-[#667085]",
      };
  }
};

export enum IMTSDocumentStatus {
  NotSent = 1,
  Sent = 2,
}

export const IMTSDocumentStatusText: Record<IMTSDocumentStatus, string> = {
  [IMTSDocumentStatus.NotSent]: "Not Sent",
  [IMTSDocumentStatus.Sent]: "Sent",
};

export const getIMTSDocumentStatusStyle = (
  status: IMTSDocumentStatus,
): { bgColor: string; textColor: string; dotColor: string } => {
  switch (status) {
    case IMTSDocumentStatus.Sent:
      return {
        bgColor: "tw-bg-[#E5EFF3]",
        textColor: "tw-text-[#146C94]",
        dotColor: "tw-bg-[#146C94]",
      };
    default:
      return {
        bgColor: "tw-bg-[#F5F5F5]",
        textColor: "tw-text-[#414651]",
        dotColor: "tw-bg-[#667085]",
      };
  }
};

export enum ImTsDocumentStatus {
  NotSent = 1,
  Sent = 2,
}
